// Fly-mode banner. A bottom-center message shown only while fly mode is active,
// listing the controls and how to leave. Standalone (own DOM element + disposer)
// like the nav-mode badge, so it survives the gnomon's projection-swap rebuild.

import { store } from '@store/instance';
import type { NavMode } from '@store/schema';

export function installFlyBanner(): () => void {
    const banner = document.createElement('div');
    banner.id = 'fly-banner';
    banner.className = 'fly-banner';
    banner.setAttribute('role', 'status');
    banner.setAttribute('aria-live', 'polite');
    banner.innerHTML =
        '<span class="fly-banner-icon" aria-hidden="true">✈</span>'
        + '<span class="fly-banner-title">Fly mode</span>'
        + '<span class="fly-banner-keys">click or drag to look · WASD move · Q/E up·down · Shift boost · '
        + '<strong>N</strong> or <strong>Esc</strong> to exit</span>';
    document.body.appendChild(banner);

    const refresh = (): void => {
        const mode = (store.get('params.navMode') as NavMode) ?? 'orbit';
        banner.dataset.active = mode === 'fly' ? 'true' : 'false';
    };

    const offMode = store.subscribe('params.navMode', () => refresh());
    refresh();

    return () => {
        offMode();
        banner.remove();
    };
}
